import { render } from "./NotificarJuridicaEmbargoPersonaComponent.vue?vue&type=template&id=4c0f63f4"
import script from "./NotificarJuridicaEmbargoPersonaComponent.vue?vue&type=script&lang=js"
export * from "./NotificarJuridicaEmbargoPersonaComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__